import React, { useContext } from "react";
import { SimpleContext } from "../../../../store/context/simple-context";
import { getTrueClasses } from "../../../../helpers";
import Option from "./Option";
import "./index.scss";

const Options = ({ optionsRef }) => {
  const {
    data: { options, currentPeriod, numberOfOptions },
    translate: { t },
  } = useContext(SimpleContext);

  return (
    <div
      className={getTrueClasses(
        "GP-C-O",
        (!currentPeriod || !options.length) && "GP-C-O_hideInfo"
      )}
      ref={optionsRef}
    >
      <p className="GP-C-O__title">
        {t(`Functional Add-${numberOfOptions > 1 ? "ons" : "on"}`)}
        <span className="GP-C-O__icon">{t("HOT")}</span>
      </p>
      <div className="GP-C-O__wrap">
        {options.length &&
          options.map((optionName) => (
            <Option key={optionName} optionName={optionName} />
          ))}
      </div>
    </div>
  );
};

export default Options;
